import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "../../shared/api/index";

export const useFetchConference = () => {
  const { fetchData } = useApi();
  const { sport, organizationId, dataId } = useParams();

  return useQuery({
    queryKey: ["conferences", organizationId, dataId],
    queryFn: async () => {
      const result = await fetchData({
        url: `${sport}/o/${organizationId}/conferences/${dataId}`,
      });
      return result?.data?.[0];
    },
    enabled: !!dataId,
  });
};
